import { connectFunctionsEmulator, getFunctions, type Functions } from 'firebase/functions';

import { env } from '@/config/env';

import { firebaseApp } from './app';

const EMULATOR_HOST = '127.0.0.1';
const FUNCTIONS_EMULATOR_PORT = 5001;

/**
 * Callable Cloud Functions client.
 *
 * Team registration and editing run server-side (docs/SECURITY.md §6.1, §6.3),
 * so the app talks to them through this client. The region is the default
 * `us-central1`, matching the deployed functions.
 */
function createFunctions(): Functions {
  const functions = getFunctions(firebaseApp);
  if (env.useEmulators) {
    connectFunctionsEmulator(functions, EMULATOR_HOST, FUNCTIONS_EMULATOR_PORT);
  }
  return functions;
}

export const firebaseFunctions: Functions = createFunctions();
